module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/online-report-3.a6453bed.svg";